export default __webpack_public_path__ + "static/media/Affordability issue.85b4c3eb.mp3";